import styled from "styled-components/macro";
import { HomeContent } from "../../../../hooks/api/queries/useHome";
import { breakpoint } from "../../../../styles/constants";
import { HomeDesktopProducts } from "./HomeDesktopProducts";
import { HomeMobileProductCarousel } from "./HomeMobileProductCarousel";

interface Props {
  item: HomeContent;
}

export const HomeProducts = ({ item }: Props) => {
  if ((item.products?.length ?? 0) === 0) return null;
  const sortedProducts = item?.products?.sort((a, b) => {
    if (a.sorting === null) return 1;
    else if (b.sorting === null) return -1;
    else return (a?.sorting ?? 0) - (b?.sorting ?? 0);
  });

  return (
    <Wrapper>
      <HomeMobileProductCarousel items={sortedProducts ?? []} />
      <HomeDesktopProducts items={sortedProducts ?? []} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3.75rem;
  @media (min-width: ${breakpoint}) {
  }

  > :first-child {
    margin-bottom: 1.25rem;
  }
`;
